var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formIsReady && !_vm.showSuccessMessage)?_c('resource-form',{attrs:{"model":_vm.form.model,"schema":_vm.form.schema,"triggers":_vm.form.triggers},on:{"submit":function($event){return _vm.addProspect($event.data)}}}):(_vm.showSuccessMessage)?_c('div',[_c('span',[_vm._v("Votre prospect vient d'être ajouté avec succès.")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a240a440","hasScoped":false,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Prospects/CreateProspect.vue
// module id = 1973
// module chunks = 0